if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        // Add the selected product and paid add-on option together. Adding the
        // LED first lets the gift reconciler remove it as an orphan.
        const formId = this.form.getAttribute('id') || '';
        const ledOption = formId.startsWith('gz-product-form-')
          ? document.getElementById('gz-rl-upsell-' + formId.slice('gz-product-form-'.length))
          : null;
        if (ledOption && ledOption.checked) {
          const ledVariantId = Number(ledOption.dataset.variantId);
          if (!Number.isSafeInteger(ledVariantId) || ledVariantId <= 0) {
            this.handleErrorMessage('The red-light option is unavailable. Please deselect it or try again.');
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading__spinner').classList.add('hidden');
            return;
          }
          const mainItem = { id: Number(formData.get('id')), quantity: Number(formData.get('quantity') || 1) };
          const properties = {};
          formData.forEach((value, key) => {
            const property = key.match(/^properties\[(.+)\]$/);
            if (property && typeof value === 'string') properties[property[1]] = value;
          });
          if (Object.keys(properties).length) mainItem.properties = properties;
          if (formData.get('selling_plan')) mainItem.selling_plan = formData.get('selling_plan');
          const payload = { items: [mainItem, { id: ledVariantId, quantity: 1 }] };
          if (formData.get('sections')) payload.sections = formData.get('sections');
          if (formData.get('sections_url')) payload.sections_url = formData.get('sections_url');
          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify(payload);
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (Array.isArray(response.items) && response.items.length) {
              response = { ...response.items[0], ...response };
            }
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                      if ((this.form.getAttribute('id') || '').indexOf('gz-product-form-') === 0 && typeof window.gzApplyKneadcalmDiscountCodes === 'function') {
                        window.gzApplyKneadcalmDiscountCodes().catch((error) => {
                          console.error('[Kneadcalm] Discount update failed:', error);
                          const promoMessage = document.querySelector('.gz-cart-promo-msg');
                          if (promoMessage) {
                            promoMessage.hidden = false;
                            promoMessage.textContent = 'The item was added, but discount codes could not be verified. The cart total shown is the latest Shopify response; checkout eligibility can still change.';
                            promoMessage.classList.add('gz-cart-promo-msg--error');
                            promoMessage.classList.remove('gz-cart-promo-msg--ok');
                          }
                        });
                      }
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
                if ((this.form.getAttribute('id') || '').indexOf('gz-product-form-') === 0 && typeof window.gzApplyKneadcalmDiscountCodes === 'function') {
                  window.gzApplyKneadcalmDiscountCodes().catch((error) => {
                          console.error('[Kneadcalm] Discount update failed:', error);
                          const promoMessage = document.querySelector('.gz-cart-promo-msg');
                          if (promoMessage) {
                            promoMessage.hidden = false;
                            promoMessage.textContent = 'The item was added, but discount codes could not be verified. The cart total shown is the latest Shopify response; checkout eligibility can still change.';
                            promoMessage.classList.add('gz-cart-promo-msg--error');
                            promoMessage.classList.remove('gz-cart-promo-msg--ok');
                          }
                        });
                }
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
